/*
 * Project: LegalPlace assistant
 * File: src\logic\wording.js
 * Author: Nasreddine DAIFALLAH
 * Version: 1.0
*/

import * as french from '../language/fr.json';
import * as de from '../language/de.json';


class lpWording {
  constructor() {
    this.language = 'fr';
    this.dicts = {
      fr: french,
      de,
    };

    this.detectLanguage();
    // console.log(this)
    // this.initIndex();
  }

  detectLanguage() {
    if (navigator.language in ['fr', 'de']) this.language = navigator.language;
    else this.language = 'fr';
    // this.language = "de"
    this.dict = this.dicts[this.language];
  }

  get(something) {
    if (this.dict.values[something]) {
      return this.dict.values[something];
    }
    return something;
  }


  initIndex() {
    const nodes = document.getElementById('contact-').childNodes;
    nodes[0].nodeValue = this.get('want help?');
    nodes[1].childNodes[0].innerText = this.get('contact us');
    nodes[1].childNodes[1].nodeValue = this.get('or');
    nodes[2].innerText = this.get('call us');
  }
}


export const lpw = new lpWording();
export const _lp = str => str;



// WEBPACK FOOTER //
// ./src/logic/wording.js